import { type ValueDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { toLongDateString } from './dateUtil';

const assignValue = (valueType: string, valueDTO: ValueDTO | undefined): string => {
    if (!valueDTO) return '';
    switch (valueType) {
        case 'LocalDateDTO':
            return toLongDateString(valueDTO.dateValue);
        case 'Boolean':
            return valueDTO.booleanValue ? 'Ja' : 'Nej';
        case 'String':
            return valueDTO.stringValue ?? '-';
        case 'AmountDTO':
            return String(valueDTO.amountValue?.amount);
        case 'TypeKey':
            return String(valueDTO.typeKeyValue);
        case 'Integer':
            return String(valueDTO.integerValue);
        default:
            throw new Error('Unknown type');
    }
};

function formatArrayToString(arr: string[], separator: string, lastSeparator: string): string {
    return arr.reduce((acc, current, index) => {
        if (index === 0) {
            return current;
        } else if (index === arr.length - 1) {
            return `${acc} ${lastSeparator} ${current}`;
        } else {
            return `${acc}${separator} ${current}`;
        }
    }, '');
}

function replaceAllCharactersButNumbers(string: string): string {
    return string.replace(/\D/g, '');
}

export { assignValue, formatArrayToString, replaceAllCharactersButNumbers };
